import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import { GraphQLHelper } from 'src/app/shared/lib/helpers/graphql.helper';
import {
  buildGetAllAyBProviderQuery,
  DEFAULT_AYB_PROVIDER_FIELDS,
} from '../graphql/proveedores.queries';

@Injectable({ providedIn: 'root' })
export class ProveedoresAybService {
  constructor(
    private graphService: GraphService,
    private graphQLHelper: GraphQLHelper,
  ) {}

  getAllWithProjection(projectionExpression?: string): Observable<any[]> {
    const requestedFields = projectionExpression
      ? projectionExpression
          .split(',')
          .map((f) => f.trim())
          .filter(Boolean)
          .filter((f) => DEFAULT_AYB_PROVIDER_FIELDS.includes(f))
      : DEFAULT_AYB_PROVIDER_FIELDS;

    const selectedAyBFields =
      requestedFields.length > 0
        ? Array.from(new Set(requestedFields))
        : DEFAULT_AYB_PROVIDER_FIELDS;

    const fields = this.graphQLHelper.buildGraphQLFields(selectedAyBFields);
    const query = buildGetAllAyBProviderQuery(fields);

    return this.graphService
      .queryGraphQLAyB<{ getAllProvider: any[] }>({
        query,
        variables: {},
      })
      .pipe(
        map((response) =>
          (response.getAllProvider || []).map((provider: any) => ({
            ...provider,
            nombre: provider.nombre ?? provider.nombreComercial,
            numRUC: provider.numRUC ?? provider.ruc,
          })),
        ),
        catchError((error) => {
          console.error('Error fetching proveedores A&B:', error);
          return throwError(() => new Error('Error al obtener proveedores A&B'));
        }),
      );
  }
}
